import React from 'react';
import spinner from '../../assets/sprites/spinner.svg';
import { FetchStatusType } from '../../../types/interfaces';

const MainSpinner = () => (
  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
    <img src={spinner} alt="Загрузка" />
  </div>
);

const Spinner = () => (
  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -mr-1/2">
    <img src={spinner} alt="Загрузка" />
  </div>
);

interface Props {
  type?: string;
  status?: FetchStatusType;
  children: React.ReactNode;
}

function LoadingWrapper({ type = '', status = 'idle', children }: Props) {
  return (
    <>
      {status === 'loading' ? (
        type === 'main' ? <MainSpinner /> : <Spinner />
      ) : (
        children
      )}
    </>
  );
}

export default LoadingWrapper;
